import { DiscoPublisherStatus } from "@redotech/congo-enums/disco-publisher-status";
import {
  falconSiteSettingsSchema,
  offerNetworkDataSharingConsentSchema,
  offerPlacementSelectionSchema,
} from "@redotech/redo-integrations-definitions-common/offer-network/offer-placement";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getOfferNetworkIntegrations = {
  name: "getOfferNetworkIntegrations" as const,
  input: z.null(),
  output: z.object({
    rokt: z.object({
      connected: z.boolean(),
      accountId: z.string().optional(),
    }),
    falcon: z.object({
      connected: z.boolean(),
      publisherId: z.string().optional(),
      siteSettings: falconSiteSettingsSchema.optional(),
    }),
    // Uptick takes no credentials; `available` is whether the team may use
    // Uptick at all (flag).
    uptick: z.object({ connected: z.boolean(), available: z.boolean() }),
    // Disco is reviewed by Disco before it serves: `status` is the review state
    // and `available` is whether the team may use Disco at all (flag).
    disco: z.object({
      connected: z.boolean(),
      status: createEnum(Object.values(DiscoPublisherStatus)).optional(),
      available: z.boolean(),
    }),
    // True when any provider is connected (provider-agnostic convenience flag).
    anyProviderConnected: z.boolean(),
    // Current Shopify thank-you page placement selection, or null when unset.
    thankYou: offerPlacementSelectionSchema.nullable(),
    // Current Shopify order status page placement selection, or null when unset.
    orderStatus: offerPlacementSelectionSchema.nullable(),
    // Data-sharing acknowledgment, or null if the merchant hasn't acknowledged.
    dataSharingConsent: offerNetworkDataSharingConsentSchema.nullable(),
  }),
};
